var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75535 2.23102L0.76873 14.3313C0.642527 14.5498 0.576073 14.7977 0.57605 15.0501C0.576026 15.3024 0.642434 15.5503 0.768597 15.7688C0.89476 15.9874 1.07623 16.1689 1.29477 16.295C1.5133 16.4212 1.7612 16.4876 2.01354 16.4876H15.9857C16.238 16.4876 16.4859 16.4212 16.7044 16.295C16.923 16.1689 17.1045 15.9874 17.2306 15.7688C17.3568 15.5503 17.4232 15.3024 17.4232 15.0501C17.4231 14.7977 17.3567 14.5498 17.2305 14.3313L10.2446 2.23102C10.1185 2.01254 9.93704 1.83112 9.71856 1.70499C9.50008 1.57886 9.25225 1.51245 8.99998 1.51245C8.74771 1.51245 8.49988 1.57886 8.2814 1.70499C8.06292 1.83112 7.8815 2.01254 7.75535 2.23102Z",
    fill: "#C91818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09112 5.96313H8.90887C8.46018 5.96313 8.09644 6.32688 8.09644 6.77557V10.6589C8.09644 11.1076 8.46018 11.4713 8.90887 11.4713H9.09112C9.53982 11.4713 9.90356 11.1076 9.90356 10.6589V6.77557C9.90356 6.32688 9.53982 5.96313 9.09112 5.96313Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.5513C9.49902 14.5513 9.90356 14.1467 9.90356 13.6477C9.90356 13.1487 9.49902 12.7441 9 12.7441C8.50097 12.7441 8.09644 13.1487 8.09644 13.6477C8.09644 14.1467 8.50097 14.5513 9 14.5513Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.82e7925a83b594983e2477ae367b2589.svg";
export { ForwardRef as ReactComponent };